import PropTypes from 'prop-types';
import React from 'react';
import Autocomplete from '../utils/Autocomplete';

class ExcludedModels extends React.Component {
  constructor(props) {
    super(props);
    this.presets = props.presets;
  }

  loadPresets = () => {
    return this.props.presets.filter(p => [3, 5].includes(p.CustomCriteriaPresetType.id));
  };

  handleSelect = selected => {
    const evt = {
      target: {
        name: 'exclusions',
        value: selected
      }
    };
    this.props.onChange(evt);
  };

  render() {
    const { value, disabled } = this.props;
    const presets = this.loadPresets();

    return (
      <Autocomplete
        disabled={disabled}
        onChange={this.handleSelect}
        value={value}
        suggestions={presets}
        name="CustomCriteriaPresets"
        suggestionKey="name"
        label={'Excluded Makes/Models'}
        placeholder="Select or start typing"
      />
    );
  }
}

ExcludedModels.defaultProps = {
  value: [],
  presetType: 0
};

ExcludedModels.propTypes = {
  value: PropTypes.array,
  presets: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default ExcludedModels;
